define(['app', 'jquery', './base'], function (app, $, Helper) {
  return Helper.extend({
    // Default class is is-hidden
    options: {
      toggleClass: 'is-hidden',
      rootIsTrigger: false,
      removeOnGlobal: false
    },

    ui: {
      trigger: '.js-trigger',
      noTrigger: '.js-no-trigger',
      target: '.js-toggle-target'
    },

    triggers: function () {
      var _triggers = {
        'click @ui.trigger': {
          event: 'toggle:class',
          stopPropagation: false
        },
        'click @ui.noTrigger': {
          event: '',
          preventDefault: false,
          stopPropagation: true
        }
      }
      if (this.options.rootIsTrigger) {
        _triggers['click'] = {
          event: 'root:toggle:class',
          stopPropagation: false
        }
      }

      return _triggers
    },

    _registerGlobalHandler: function () {
      var self = this
      $(window.document).one('click', function () {
        self._getTargetEl().removeClass(self.options.toggleClass)
      })
    },

    _getTargetEl: function () {
      var targetEl = this.$el.find(this.ui.target)
      if (!targetEl.length) {
        targetEl = this.$el
      }
      return targetEl
    },

    onRootToggleClass: function () {
      if (this.options.rootIsTrigger) {
        return this.onToggleClass.apply(this, arguments)
      }
    },

    onToggleClass: function () {
      var target = this._getTargetEl()
      if (!target.hasClass(this.options.toggleClass)) {
        if (this.options.removeOnGlobal) {
          // setTimeout to prevent double toggle
          setTimeout(this._registerGlobalHandler.bind(this))
        }
        target.addClass(this.options.toggleClass)
      } else {
        target.removeClass(this.options.toggleClass)
      }
    }
  })
})
